import {
  TELEMETRY_REPORTED_WINDOW,
  getTelemetryReportedWindowOptions,
} from 'src/utils/enums/telemetryReportedWindow';
import { SIGNED_FILTER_OPTION } from '../Win32FileTable';

// Files the app does not cover are what this page exists to work down, so the table starts there.
// A null isCovered shows every reported file. Reports are read over the last 90 days by default,
// the furthest telemetry goes back, and the same window the status form offers to import.
export const DEFAULT_TELEMETRY_FILTERS = {
  reportedWindow: TELEMETRY_REPORTED_WINDOW.Last90Days,
  isCovered: false,
  isSigned: [],
};

export const COVERAGE_CARDS = [
  {
    isCovered: false,
    label: 'Not Covered by App',
    countKey: 'uncoveredFileCount',
    nextStep: 'Create WDAC Import to add to the application',
  },
  {
    isCovered: true,
    label: 'Covered by App',
    countKey: 'coveredFileCount',
    nextStep: 'Deploy your latest policy to reduce reports',
  },
];

export const TELEMETRY_FILTER_OPTIONS = [
  {
    key: 'reportedWindow',
    type: 'radio',
    label: 'Reported',
    options: getTelemetryReportedWindowOptions(),
  },
  SIGNED_FILTER_OPTION,
  {
    key: 'isCovered',
    type: 'select',
    label: 'Coverage',
    dataType: 'boolean',
    options: [
      { value: '', label: 'All reported files' },
      ...COVERAGE_CARDS.map(card => ({ value: card.isCovered, label: card.label })),
    ],
  },
];

// A window the URL left out, or a radio clicked off, falls back to the default rather than to no
// window, since the server always reads one.
export const withReportedWindow = filters => ({
  ...filters,
  reportedWindow: filters.reportedWindow || DEFAULT_TELEMETRY_FILTERS.reportedWindow,
});
